// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"3bb92953","161":"8788226e","453":"c236b0ab","486":"16fc22d9","648":"803b9810","789":"dd73f165","989":"06ebd1c4"}[chunkId] + ".chunk.js";
};